import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Typography } from "@mui/material";

import { ProgressButton } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

export function AddWorkstationButton({
  addWorkstation,
  isCreating,
  disabled = false
}: {
  addWorkstation: () => Promise<void>;
  isCreating: boolean;
  /** True when no free ports remain on the selected grid (button stays visible, not clickable). */
  disabled?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <ProgressButton
      id="add-workstation-button"
      emphasis="high"
      buttonSize="medium"
      responsive
      color="primary"
      sx={{
        width: { xs: "100%", sm: "auto" },
        minWidth: { sm: 200 },
        maxWidth: { sm: 320 },
        alignSelf: "flex-end"
      }}
      onClick={async () => {
        await addWorkstation();
        return null;
      }}
      disabled={isCreating || disabled}
    >
      <AddCircleIcon />
      <Typography sx={{ ml: 2 }}>{t("create workstation")}</Typography>
    </ProgressButton>
  );
}
